import React from 'react';
import {
    DropdownThemedButton,
    ThemedButton,
} from '@awarego-ui/components';
import { Link } from 'react-router-dom';

function CreateAssessmentButton({
    cmi5enabled,
    isAssessmentInsight,
    buttonParams,
    buttonStyle,
    links = {
        regularLink: isAssessmentInsight ? '/assessment-insight/create' : '/assessment/create',
        scormLink: '/assessment/create_scorm',
    },
    texts = {
        singleButton: 'Create new',
        dropdownButtonRegular: 'Assessment',
        dropdownButtonScorm: 'Assessment (SCORM, cmi5)',
    },
}) {
    if (!cmi5enabled || isAssessmentInsight)
        return (
            <ThemedButton
                mode="primary"
                text={texts.singleButton}
                as={Link}
                to={links.regularLink}
                $center
                style={{display: 'flex'}}
                {...buttonParams}
                {...buttonStyle}
            />
        );
    return (
        <DropdownThemedButton
            text={texts.singleButton}
            btnProps={{ mode: 'primary', $center: true, ...buttonParams }}
            items={[
                {
                    text: texts.dropdownButtonRegular,
                    props: {
                        component: Link,
                        to: links.regularLink,
                    },
                },
                {
                    text: texts.dropdownButtonScorm,
                    props: {
                        component: Link,
                        to: links.scormLink,
                    },
                },
            ]}
        />
    );
}

export default CreateAssessmentButton;
